import React from 'react';
import { Link } from 'react-router-dom';
import icons from '../../../helpers/Icons';

class DetailsLink extends React.Component {
    render() {
        const {entity, id} = this.props;
        //(entity == 'imprints') ? null : 
        return (id ? <Link to={`/${entity}/${id}`} {...this.props}><span className="chart-icon entities-icon" dangerouslySetInnerHTML={{__html: icons.entities[entity]}}></span></Link> : null);
    }
}

export default DetailsLink